import { CustomerEmail } from './customer-email';
import { Provider } from './provider';
import { ReceivedDate } from './received-date';
import { ReturningParty } from './returning-party';
import { ReturnsCity } from './returns-city';
import { ReturnsCountry } from './returns-country';
import { ReturnsLabel } from './returns-label';
import { ReturnsState } from './returns-state';
import { RmaNumber } from './rma-number';
import { ReturnTo } from './return-to';

export const UniqueOptions = [
  CustomerEmail,
  Provider,
  ReceivedDate,
  ReturningParty,
  ReturnsCity,
  ReturnsCountry,
  ReturnsLabel,
  ReturnsState,
  RmaNumber,
  ReturnTo,
];
